const orange = {
  light: '#FFF3EB',
  main: '#FF8533',
  dark: '#FF6600'
};
export default orange;